export const DYNAMIC_CUSTOM_TYPES = {
  marketing_campaign_post: {
    url: (uid) => {
      return `/campaigns/${uid}`
    },
    title: 'Campaign',
  },
}
